export default "__VITE_ASSET__C9WkF0BS__"